import * as React from 'react';
import { Mutation } from 'react-apollo';
import type { MutationFn } from 'react-apollo';

import type { Submission_FileUploadQuestionGenerateUploadUrlInput as FileUploadQuestionGenerateUploadUrlInput } from '__generated__/graphql-types';
import type { UploadUrlResult_Header as AdditionalHeaders } from '__generated__/graphql-types-do-not-use';

import GetPreSignedUrl from 'bundles/fileuploader-uppy/components/api/PreSignedUrl.graphql';
import type {
  GetPreSignedUrlMutation,
  GetPreSignedUrlMutationVariables,
} from 'bundles/fileuploader-uppy/components/api/__generated__/PreSignedUrl';

export type GetPreSignedUrlInput = {
  contentMd5?: string;
  contentType: string;
  fileName: string;
};

export type GetPreSignedUrlResult = {
  url?: string;
  additionalHeaders: Array<AdditionalHeaders>;
};

export type PreSignedUrlProviderProps = {
  children: (
    getPreSignedUrl: (input: GetPreSignedUrlInput) => Promise<GetPreSignedUrlResult>
  ) => React.ReactElement | null;
};

const handleGetPreSignedUrl = (
  getPreSignedUrlMutation: MutationFn<GetPreSignedUrlMutation, GetPreSignedUrlMutationVariables>
) => {
  return async ({ contentMd5, contentType, fileName }: FileUploadQuestionGenerateUploadUrlInput) => {
    const result = await getPreSignedUrlMutation({
      variables: {
        input: {
          contentMd5,
          contentType,
          fileName,
        },
      },
    });

    const response = result?.data?.Submission_FileUploadQuestionGenerateUploadUrl;
    return {
      url: response?.url,
      additionalHeaders: response?.additionalHeaders || [],
    };
  };
};

const PreSignedUrlProvider: React.FC<PreSignedUrlProviderProps> = ({ children }) => {
  return (
    <Mutation<GetPreSignedUrlMutation, GetPreSignedUrlMutationVariables>
      mutation={GetPreSignedUrl}
      context={{ clientName: 'gatewayGql' }}
    >
      {(getPreSignedUrlMutation) => children(handleGetPreSignedUrl(getPreSignedUrlMutation))}
    </Mutation>
  );
};

export default PreSignedUrlProvider;
